module.exports = __webpack_public_path__ + "static/img/produto_g.92cafa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/oitosegundos/produto_g.png
// module id = T4VH
// module chunks = 0